// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { setFavicon } from "@/lib/setFavicon";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
// (optional in dev)
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

setFavicon(); 

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* optional: remove in prod */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
